import { Component, OnInit } from '@angular/core';
import { AlertController, IonicModule } from '@ionic/angular';
import { AuthProvider } from "../../providers/auth/auth";
// import { InAppBrowser} from '@ionic-native/in-app-browser/ngx';
import { HomePage } from '../home/home';
import { LandingPage } from '../landing/landing';
import { UserDataProvider } from '../../providers/user-data/user-data';
//import { RefdataProvider } from '../../providers/refdata/refdata';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the WebloginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-weblogin',
  templateUrl: 'weblogin.html',
  styleUrls: ['./weblogin.scss'],
  standalone: false,
//  imports: [
//    CommonModule,
//    IonicModule,
//    FormsModule,
//    TranslateModule
//  ]
})
export class WebloginPage implements OnInit {
  public static PATH: string = 'weblogin';

  private currentCode: string = '';

  constructor(
    public router: Router,
    private auth: AuthProvider,
//    private inAppBrowser: InAppBrowser,
    public alertCtrl: AlertController,
    private userData: UserDataProvider,
    private plt: Platform
  ) { 
    console.log("Weblogin: constructor")
  }
  ngOnInit(): void {
    console.log("Weblogin: ngOnInit called")
    this.auth.isLoggedIn().then((isLoggedIn) => {
      console.log('WebloginPage: checked if isLoggedIn');
      if (isLoggedIn) {
        console.log('WebloginPage: isLoggedIn -> showing SuccessPage');
        this.showSuccessPage();
      }
      else {
        let loggedIn2: boolean = this.auth.login(this);
        if (loggedIn2) {
          console.log('WebloginPage: isLoggedIn2 -> showing SuccessPage');
          this.showSuccessPage();
        }
        else {
          console.log('WebloginPage: NOT isLoggedIn -> showing AuthWindow');
          this.showAuthWindow();
        }
      }
    });
  }

  ionViewWillEnter() {
    console.log('ionViewWillEnter WebloginPage');
  }

  ionViewDidEnter() {
    console.log('WebloginPage: called ionViewDidEnter');
// OLD    this.showAuthWindow();
  }
  showAuthWindow() {
    if (this.auth.isInApp()) {
      this.showAuthWindowOnDevice();
    }
    else {
      this.showAuthWindowInBrowser();
    }
  }
  showAuthWindowOnDevice() {
    this.log("showing auth window from app");

    this.plt.ready().then(() => {
      let redirecturl : string = 'http://localhost:8100/';
      let loginurl : string = this.auth.getLoginUrl(redirecturl);
      // let browser = this.inAppBrowser.create(loginurl, "_blank", "location=no,hidden=no,clearcache=yes,clearsessioncache=yes");
      let browser = open(loginurl, "_blank", "location=no,hidden=no,clearcache=yes,clearsessioncache=yes");
      // let browser = open(e.url, "_system", "location=true");
      browser.addEventListener("loadstart",
//      browser.on("loadstart")
//      .subscribe(
        (event: any) => {
          this.log("event loadstart: " + event.url);
//          browser.hide();
          browser.close()

          if (event.url) {
            if (event.url.startsWith('http://localhost:8100/?code=')) {
              this.log('event loadstart: url with code detected');
              let code: string = this.auth.getCodeFromURL(event.url);
              this.log('loadstart: new code = ' + code);
              if (code != this.currentCode) {
                this.log('loadstart: new code (' + code + ') is different from previous code (' + this.currentCode + ')');
                this.currentCode = code;
                this.auth.getUserAndContinue(code, this);
//                browser.hide();
              }
              else {
                this.log('loadstart: new code (' + code + ') is the same as previous code (' + this.currentCode + '): doing nothing');
              }
            }
            else { // not logged in properly: user only signed up (and login backend redirected to redirecturl)
              if (event.url == redirecturl) {
                console.log('Sending to application without login code, sending back to login');
                browser.location = loginurl;
//                browser.executeScript({code:'window.location="' + loginurl + '";'}).then((cookie)=>{
//                  console.log('Redirected to ' + loginurl);
//                });
              }
              else if (event.url == loginurl) {
                console.log('Sending to login, no special loadstart action required');
              }
              else { // this is any other url: just allow
                console.log('Sending to other event url #' + event.url + '#, no special loadstart action required');
              }
            }
          }
        },
//        err => {
//          this.log("error: " + err);
//          // last resort: try to go to landing page
//          this.showLandingPage();
//        }
      );

      browser.addEventListener("loadstop",
//      browser.on("loadstop")
//      .subscribe(
        (event:any) => {
          this.log("event loadstop: " + event.url);
          this.log("event code = " + event.code);
          this.log('even.message = ' + event.message);
          this.log('event.returnValue = ' + event.returnValue);

          //check to see if the login worked
          if(event.url) {
            if (event.url.indexOf("signup") >= 0) {
              console.log("event.url was a signup url");
//              browser.show();
            }
            else {
              // browser.executeScript({ code: "document.body.innerHTML" }).then(
              //   (result) => {
              //     var temp = document.createElement("div");
              //     temp.innerHTML = result;
              //     var sanitized = temp.textContent || temp.innerText;
              //     /*var output = '';
              //     for (var property in result) {
              //       output += property + ': ' + result[property]+'; ';
              //     }
              //     this.log(output);*/
              //     this.log(sanitized.substr(0, 50));
              //     if (sanitized.startsWith('{')) {
              //       this.log(JSON.parse(sanitized).id);
              //       let userid = JSON.parse(sanitized).id;
              //       this.userData.login(userid);
              //       //this.log(JSON.stringify(result));
              //       browser.close();
              //     }
              //     else {
              //       this.log('no json, continuing ...');
              //       browser.show();
              //     }
              //   }
              // );
            }
          }
        },
//        err => {
//          this.log("error: " + err);
//          // last resort: try to go to landing page
//          this.showLandingPage();
//        }
      );

      browser.addEventListener("loaderror",
//      browser.on("loaderror")
//      .subscribe(
        (event: any) => {
          this.log("event loaderror: " + event.url + 'code = ' + event.code + ', message=' + event.message);
        },
//        err => {
//          this.log("error: " + err);
//          // last resort: try to go to landing page
//          this.showLandingPage();
//        }
      );

      
      browser.addEventListener("exit",
//      browser.on("exit")
//      .subscribe(
        (event: any) => {
          this.log("event exit: " + event.url);
          this.showSuccessPage();
        },
//        err => {
//          this.log("error: " + err);
//          // last resort: try to go to landing page
//          this.showLandingPage();
//        }
      );
  }); // end of plt ready then
  }
  showAuthWindowInBrowser() {
    this.log("showing auth window in browser");

    let redirecturl : string = this.auth.cleanURL(this.plt.url()); // window.location.href;
    this.log('showAuthWindow2InBrowser: redirect url = ' + redirecturl);
    let url : string = this.auth.getLoginUrl(this.auth.cleanURL(this.plt.url()));

    window.open(url, "_self", "location=no,clearcache=yes,clearsessioncache=yes"); // open(e.url, "_system", "location=true");
  }

  handleUserId(result: any) {
    this.log("result: " + result);
    this.log("id: " + result.id);
  }

  log(s: string) {
    console.log((new Date()).toString() + ' - ' + s);
  }
  public showSuccessPage() {
    this.showPage(HomePage);
  }
  public showLandingPage() {
    this.showPage(LandingPage);
  }
  public showPage(pageToShow) {
    this.router.navigate([ pageToShow.PATH ]).catch(err => {
      let alertProm = this.alertCtrl.create({
        header: 'Authentication failed',
        subHeader: 'No access',
        buttons: ['OK']
      });
      alertProm.then((alert) => alert.present());
    });
  }

}
